var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBackBtn)?_c('b-button',{staticClass:"gid-back-btn",attrs:{"variant":"primary"},on:{"click":_vm.clickBackBtn}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }